import { useTranslation } from 'react-i18next';
import { useEditGroupPreWork } from './useEditGroup';
import { GroupCandidatesTablePrework } from '../GroupCandidatesTablePrework';

export const EditGroupContainerPrework = () => {
	const { t } = useTranslation();
	const { group } = useEditGroupPreWork();
	const groupName = group?.preworkGroupName;
	const preworkGroupMembersWithoutKey = group?.preworkGroupMembers;
	const preworkGroupMembers =
		preworkGroupMembersWithoutKey &&
		preworkGroupMembersWithoutKey.map((candidate) => ({
			...candidate,
			key: candidate.applicationId,
		}));

	return (
		<div className="p-8">
			<h2>{t('editGroupWithGroupName', { groupName })}</h2>
			<GroupCandidatesTablePrework
				groupCandidates={preworkGroupMembers}
				isEditGroupTable={true}
			/>
		</div>
	);
};
